import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../index/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/",
    name: "index",
    component: Home,
    children: [
      {
        path: "/index",
        component: () =>
          import(/* webpackChunkName: "Index" */ "../views/home/home.vue"),
        meta: {
          title: "首页",
          keepAlive: true,
        },
      },
      {
        path: "/agreementDetial",
        component: () =>
          import(
            /* webpackChunkName: "receiveCoupon" */ "../views/agreement/agreementDetial.vue"
          ),
        meta: {
          title: "小筑教育-协议管理",
        },
      },
      {
        path: "/downApp",
        component: () =>
          import(
            /* webpackChunkName: "receiveCoupon" */ "../views/downApp/downApp.vue"
          ),
        meta: {
          title: "小筑教育-下载app",
        },
      },
      {
        path: "/lookLive",
        component: () =>
          import(
            /* webpackChunkName: "receiveCoupon" */ "../views/live/lookLive.vue"
          ),
        meta: {
          title: "小筑教育-观看直播",
        },
      },
      {
        path: "/login",
        component: () =>
          import(
            /* webpackChunkName: "login" */ "../views/user/login/login.vue"
          ),
        meta: {
          title: "登陆",
        },
      },
            // /* webpackChunkName: "login" */ "../views/seleClass/seleClass.vue"
            // /* webpackChunkName: "login" */ "../views/classification/classification.vue"

      {
        path: "/classification",
        component: () =>
          import(
            /* webpackChunkName: "login" */ "../views/seleClass/seleClass.vue"
          ),
        meta: {
          title: "课程分类",
          keepAlive: true,

        },
      },
      {
        path: "/register",
        component: () =>
          import(
            /* webpackChunkName: "register" */ "../views/user/register/register.vue"
          ),
        meta: {
          title: "注册",
        },
      },
      {
        path: "/retrievePwd",
        component: () =>
          import(
            /* webpackChunkName: "retrievePwd" */ "../views/user/retrievePwd/retrievePwd.vue"
          ),
        meta: {
          title: "找回密码",
        },
      },
      {
        path: "/liveList",
        component: () =>
          import(
            /* webpackChunkName: "index" */ "../views/liveList/index.vue"
          ),
        meta: {
          title: "小筑教育",
          keepAlive: true
        },
      },
      {
        path: "/BIMDetials",
        component: () =>
          import(
            /* webpackChunkName: "detials" */ "../components/liveList/BIM/detials.vue"
          ),
        meta: {
          title: "资料详情",
        },
      },
      {
        path: "/lookData",
        component: () =>
          import(
            /* webpackChunkName: "detials" */ "../components/liveList/BIM/lookData.vue"
          ),
        meta: {
          title: "资料列表",
        },
      },
      {
        path: "/tui",
        component: () =>
          import(
            /* webpackChunkName: "detials" */ "../components/test/tui.vue"
          ),
        meta: {
          title: "退款测试",
        },
      },
      {
        path: "/payment",
        component: () =>
          import(
            /* webpackChunkName: "payment" */ "../components/payment/payment.vue"
          ),
        meta: {
          title: "资料详情",
        },
      },
      {
        path: "/learning",
        component: () =>
          import(
            /* webpackChunkName: "learningCenter" */ "../views/learn/learning.vue"
          ),
        meta: {
          title: "学习中心",
        },
      },
      {
        path: "/chapter",
        component: () =>
          import(
            /* webpackChunkName: "catalogue" */ "../views/learn/chapter.vue"
          ),
        meta: {
          title: "学习中心",
        },
      },
      {
        path: "/curriculum",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "../views/learn/curriculum.vue"
          ),
        meta: {
          title: "课程",
        },
      },
      {
        path: "/class",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "../views/class/class.vue"
          ),
        meta: {
          title: "课程",
        },
      },
      {
        path: "/classPay",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "../views/class/pay.vue"
          ),
        meta: {
          title: "确认订单",
        },
      },
      {
        path: "/study",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "../views/study/study.vue"
          ),
        meta: {
          title: "学习",
        },
      },
      {
        path: "/QQLogin",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "@/components/login/QQLogin.vue"
          ),
        meta: {
          title: "QQ授权登录",
        },
      },
      {
        path: "/examList",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "../views/exam/examList.vue"),
        meta: {
          title: "考试列表",
          keepAlive: true
        },
      },
      {
        path: "/addExam",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "../views/exam/addExam.vue"),
        meta: {
          title: "考试报名",
          keepAlive: true
        },
      },
      {
        path: "/mine",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "../views/mine/mine.vue"),
        meta: {
          title: "我的",
          keepAlive: true
        },
      },
      {
        path: "/agreementList",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "../views/agreement/agreementList.vue"),
        meta: {
          title: "协议管理",
          keepAlive: true
        },
      },
      {
        path: "/otherO",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "../views/other/one.vue"),
        meta: {
          title: "小筑一起学BIM",
        },
      },
      {
        path: "/setting",
        component: () =>
          import(/* webpackChunkName: "curriculum" */ "@/components/mine/setting/setting.vue"),
        meta: {
          title: "设置",
        },
      },
      {
        path: "/coupon",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "@/components/mine/orderCoupon/coupon.vue"
          ),
        meta: {
          title: "我的优惠卷",
        },
      },
      {
        path: "/paySuc",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "@/components/liveList/BIM/paySuc.vue"
          ),
        meta: {
          title: "支付",
        },
      },
      {
        path: "/classPayResult",
        component: () =>
          import(
            /* webpackChunkName: "curriculum" */ "@/components/class/pay/payResult.vue"
          ),
        meta: {
          title: "支付",
        },
      },
      {
        path: "/details",
        component: () =>
          import(
            "../views/class/class.vue"
            /* webpackChunkName: "curriculum" */
            // "../views/course/details.vue"
          ),
        meta: {
          title: "课程详情",
        },
      },
      {
        path: "/receiveCoupon",
        component: () =>
          import(
            /* webpackChunkName: "receiveCoupon" */ "../views/coupon/receiveCoupon.vue"
          ),
        meta: {
          title: "领取优惠券",
        },
      },
      {
        path: "/selectCoupon",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/coupon/selectCoupon.vue"
          ),
        meta: {
          title: "选择优惠券",
        },
      },
      {
        path: "/payResult",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/pay/payResult.vue"
          ),
        meta: {
          title: "支付成功",
        },
      },
      {
        path: "/pay",
        component: () =>
          import(/* webpackChunkName: "selectCoupon" */ "../views/pay/pay.vue"),
        meta: {
          title: "确认订单",
        },
      },
      {
        path: "/isPay",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/pay/isPay.vue"
          ),
        meta: {
          title: "确认支付",
        },
      },
      {
        path: "/order",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/order/order.vue"
          ),
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "/orderDetial",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../components/mine/orderCoupon/order/orderDetial.vue"
          ),
        meta: {
          title: "订单详情",
        },
      },
      {
        path: "/UnpaidOrder",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../components/mine/orderCoupon/oeder.vue"
          ),
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "/live",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/live/Details.vue"
          ),
        meta: {
          title: "直播",
        },
      },
      {
        path: "/livelogin",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/live/Login.vue"
          ),
        meta: {
          title: "登录",
        },
      },
      {
        path: "/liveerror",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/live/Failed.vue"
          ),
        meta: {
          title: "错误",
        },
      },
      {
        path: "/livevideo",
        component: () =>
          import(
            /* webpackChunkName: "selectCoupon" */ "../views/live/Video.vue"
          ),
        meta: {
          title: "直播",
        },
      },
    ],
  },
  {
    path: "/enterprise",
    component: () =>
      import(
        /* webpackChunkName: "receiveCoupon" */ "../views/enterprise/enterprise.vue"
      ),
    meta: {
      title: "领取优惠券",
    },
  },
  {
    path: "/404",
    name: "notFound",
    component: () =>
      import(
        /* webpackChunkName: "selectCoupon" */ "../views/common/404.vue"
      )
  },
  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
